import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider, type FronteggConfig } from '@tune/frontegg-react';
import { App } from './App';
import './styles/global.css';

const fronteggConfig: FronteggConfig = {
  authOptions: {
    keepSessionAlive: true,
  },
  contextOptions: {
    appId: import.meta.env.VITE_FRONTEGG_APP_ID,
    baseUrl: import.meta.env.VITE_FRONTEGG_BASE_URL,
    clientId: import.meta.env.VITE_FRONTEGG_CLIENT_ID,
  },
  hostedLoginBox: true,
};

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider config={fronteggConfig}>
      <App />
    </AuthProvider>
  </StrictMode>
);
